import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('pricing');

const GET_TAGS = define('GET_TAGS', true);
const GET_BOOKING_LOCATION_DATA = define('GET_BOOKING_LOCATION_DATA', true);
const CLEAR_TAGS = define('CLEAR_TAGS');
const CLEAR_BOOKING_DATA_LIST = define('CLEAR_BOOKING_DATA_LIST');
const ADD_CUSTOM_TAG = define('ADD_CUSTOM_TAG');

const initialState = {
  tags: [],
  bookingDataList: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TAGS.RESOLVED:
      return {
        ...state,
        tags: action.data,
      };
    case CLEAR_TAGS:
      return {
        ...state,
        tags: []
      };
    case ADD_CUSTOM_TAG:
      return {
        ...state,
        tags: [...state.tags, action.tag]
      };
    case GET_BOOKING_LOCATION_DATA.RESOLVED:
      return {
        ...state,
        bookingDataList: action.data
      };
    case CLEAR_BOOKING_DATA_LIST:
      return {
        ...state,
        bookingDataList: []
      };
    default: return state;
  }
};

export const actions = {
  getTags: (txt) => ({
    type: GET_TAGS,
    promise: api.post('/bookings/get-tags', { txt }),
  }),
  clearTags: () => ({
    type: CLEAR_TAGS,
  }),
  getBookingLocationData: (tags = [], matchExactly) => ({
    type: GET_BOOKING_LOCATION_DATA,
    promise: api.post('/bookings/get-booking-location-data', { tags, matchExactly }),
  }),
  clearBookingDataList: () => ({
    type: CLEAR_BOOKING_DATA_LIST,
  }),
  addCustomTag: (tag) => ({
    type: ADD_CUSTOM_TAG,
    tag
  })
};



// WEBPACK FOOTER //
// ./src/ducks/pricing.js